import I18N from '@leverege/i18n';
const {
  t
} = I18N.ns('temporaryUserManagement.Defaults');
export default {
  expirationIntervals: [{
    name: '24Hours',
    get displayName() {
      return t('24Hours');
    },
    value: () => ({
      validAfter: Date.now(),
      expiresAt: Date.now() + 1000 * 60 * 60 * 24
    })
  }, {
    name: '1Week',
    get displayName() {
      return t('1Week');
    },
    value: () => ({
      validAfter: Date.now(),
      expiresAt: Date.now() + 1000 * 60 * 60 * 24 * 7
    })
  }, {
    name: '30Days',
    get displayName() {
      return t('30Days');
    },
    value: () => ({
      validAfter: Date.now(),
      expiresAt: Date.now() + 1000 * 60 * 60 * 24 * 30
    })
  }, {
    name: 'custom',
    get displayName() {
      return t('custom');
    },
    value: cxt => ({
      validAfter: cxt.validAfter,
      expiresAt: cxt.expiresAt
    })
  }],
  defaultExpirationInterval: '24Hours',
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  timeFormat: 'MM-DD-YY hh:mm A'
};